import { Zap, Package, Palette, FileDown, Headset, Recycle, Sparkles } from "lucide-react";
import FaqAccordion from "../../components/FaqAccordion";

const ICONS = { Zap, Package, Palette, FileDown, Headset, Recycle };

export function BoxTeasers({ teasers = [] }) {
  if (!teasers.length) return null;
  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 border border-slate-200 bg-white divide-x divide-y lg:divide-y-0 divide-slate-200" data-testid="box-teasers">
      {teasers.map((t) => {
        const Icon = ICONS[t.icon] || Sparkles;
        return (
          <div key={t.title} className="p-5 text-center">
            <Icon className="w-7 h-7 mx-auto text-kolt-orange" strokeWidth={1.5} />
            <div className="text-xs font-semibold text-kolt-slate mt-3 leading-snug">{t.title}</div>
          </div>
        );
      })}
    </div>
  );
}

export function BoxDetails({ product }) {
  const d = product.box_details || {};
  const sections = [
    [d.intro_title || `${product.name}s`, d.intro],
    ["Inks", d.inks],
    ["Our materials", d.materials],
    ["Our process", d.process],
    ["Product guarantee", d.guarantee],
    ["Sustainability promise", d.sustainability],
    ["Shipping", d.shipping],
  ].filter(([, v]) => v);
  return (
    <section data-testid="box-details">
      <div className="overline mb-2">Product details</div>
      <div className="grid md:grid-cols-2 gap-x-12 gap-y-8">
        {sections.map(([h, body]) => (
          <div key={h}>
            <h3 className="font-heading text-xl font-bold text-kolt-slate mb-2">{h}</h3>
            <p className="text-sm text-slate-600 leading-relaxed">{body}</p>
          </div>
        ))}
      </div>
      {product.proof_options?.length > 0 && (
        <div className="mt-10 bg-kolt-slate-dark text-white p-6 sm:p-8" data-testid="box-proof-options">
          <div className="text-xs font-mono uppercase tracking-[0.28em] text-kolt-orange">Proof & sample options</div>
          <div className="grid md:grid-cols-3 gap-6 mt-4">
            {product.proof_options.map((p, i) => (
              <div key={p.title}>
                <div className="font-heading text-lg font-bold"><span className="text-kolt-orange mr-2">{i + 1}.</span>{p.title}</div>
                <p className="text-sm text-slate-300 mt-2 leading-relaxed">{p.text}</p>
              </div>
            ))}
          </div>
        </div>
      )}
      <div className="mt-10"><FaqAccordion items={product.faqs || []} /></div>
    </section>
  );
}

